import {
  Box,
  Button,
  ControllerModal,
  DialogContent,
  Typography,
} from '@bymason-private/legacy-pattern-components';
import { XrayRtcFeature } from '@bymason/controller-api-hooks';
import { useMemo } from 'react';

interface DataUsageWarningModalProps {
  feature: XrayRtcFeature;
  deviceName: string;
  open: boolean;
  onClose: (proceed?: boolean) => void;
}

export function DataUsageWarningModal({ deviceName, onClose, open, feature }: DataUsageWarningModalProps) {
  const handleProceed = () => {
    onClose(true);
  };

  const handleCancel = () => {
    onClose();
  };

  const message = useMemo(() => {
    const featureMap: Record<string, string> = {
      ['remote-control']: 'remote control',
      ['log-stream']: 'streaming logs',
    };
    return `Launching ${featureMap[feature] || 'X-Ray'} may incur cellular data charges on the target device`;
  }, [feature]);

  return (
    <ControllerModal onClose={handleCancel} open={open} subTitle={message} title='Data charges may apply'>
      <DialogContent>
        <Typography pb={2}>
          Do you still want to connect to <strong>{deviceName}</strong>?
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            gap: 2,
            marginTop: 7,
          }}
        >
          <Button color='secondary' onClick={handleCancel} size='medium' variant='text'>
            Cancel
          </Button>
          <Button color='primary' onClick={handleProceed} size='medium' variant='contained'>
            Yes, proceed
          </Button>
        </Box>
      </DialogContent>
    </ControllerModal>
  );
}
